import { Typography } from "antd";
import { TypographyProps } from "antd/lib/typography/Typography";
import { useMemo } from "react";
import color from "../../../theme/color";
import { textTagSize } from "../utils/textTheme";
import { TagSizes } from "../utils/theme";

interface TextTagProps extends TypographyProps<any> {
  colors: string;
  ghost?: boolean;
  size?: TagSizes;
}

/**
 * 텍스트 라벨 컴포넌트
 * @param param0
 * @returns
 */
export const TextTag: React.FC<TextTagProps> = ({
  colors,
  style,
  size = "medium",
  ...props
}) => {
  const sizes = useMemo(() => {
    const scale: { [k: string]: any } = { ...textTagSize };

    if (size) {
      return scale[size] || undefined;
    }

    return undefined;
  }, [size]);

  return (
    <Typography.Text
      style={{
        color: colors || color.gray2,
        ...(sizes && {
          fontSize: sizes[0],
          lineHeight: sizes[1],
          fontWeight: sizes[2],
        }),
        ...style,
      }}
      {...props}
    />
  );
};
